import { createFileRoute } from '@tanstack/react-router';

import { conciliationDetailScreen, detailSearch, loadConciliationMessages, loadConciliationScreens } from '@/modules/conciliation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Detalhe da conciliação (`router.tsx:1484-1511`); as abas do legado viram `?tab=` (S29).
export const Route = createFileRoute('/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/')({
  validateSearch: detailSearch,
  staticData: { screen: conciliationDetailScreen },
  loader: () => loadConciliationMessages(),
  component: lazyScreen(loadConciliationScreens, 'ConciliationDetailRouteScreen'),
});
